export const idlFactory = ({ IDL }) => {
  const CandyShared = IDL.Rec();
  const VarType = IDL.Rec();
  const PropertyShared = IDL.Record({
    'value' : CandyShared,
    'name' : IDL.Text,
    'immutable' : IDL.Bool,
  });
  CandyShared.fill(
    IDL.Variant({
      'Int' : IDL.Int,
      'Map' : IDL.Vec(IDL.Tuple(CandyShared, CandyShared)),
      'Nat' : IDL.Nat,
      'Set' : IDL.Vec(CandyShared),
      'Nat16' : IDL.Nat16,
      'Nat32' : IDL.Nat32,
      'Nat64' : IDL.Nat64,
      'Blob' : IDL.Vec(IDL.Nat8),
      'Bool' : IDL.Bool,
      'Int8' : IDL.Int8,
      'Ints' : IDL.Vec(IDL.Int),
      'Nat8' : IDL.Nat8,
      'Nats' : IDL.Vec(IDL.Nat),
      'Text' : IDL.Text,
      'Bytes' : IDL.Vec(IDL.Nat8),
      'Int16' : IDL.Int16,
      'Int32' : IDL.Int32,
      'Int64' : IDL.Int64,
      'Option' : IDL.Opt(CandyShared),
      'Floats' : IDL.Vec(IDL.Float64),
      'Float' : IDL.Float64,
      'Principal' : IDL.Principal,
      'Array' : IDL.Vec(CandyShared),
      'Class' : IDL.Vec(PropertyShared),
    })
  );
  const GovernanceRequest = IDL.Variant({
    'update_system_var' : IDL.Record({
      'key' : IDL.Text,
      'val' : CandyShared,
      'token_id' : IDL.Text,
    }),
    'clear_shared_wallets' : IDL.Text,
  });
  const GovernanceResponse = IDL.Variant({
    'update_system_var' : IDL.Bool,
    'clear_shared_wallets' : IDL.Bool,
  });
  const NFTErrors = IDL.Variant({
    'nyi' : IDL.Null,
    'storage_configuration_error' : IDL.Null,
    'escrow_withdraw_payment_failed' : IDL.Null,
    'token_not_found' : IDL.Null,
    'owner_not_found' : IDL.Null,
    'content_not_found' : IDL.Null,
    'auction_ended' : IDL.Null,
    'out_of_range' : IDL.Null,
    'sale_id_does_not_match' : IDL.Null,
    'sale_not_found' : IDL.Null,
    'kyc_fail' : IDL.Null,
    'item_not_owned' : IDL.Null,
    'property_not_found' : IDL.Null,
    'validate_trx_wrong_host' : IDL.Null,
    'withdraw_too_large' : IDL.Null,
    'content_not_deserializable' : IDL.Null,
    'bid_too_low' : IDL.Null,
    'validate_deposit_wrong_amount' : IDL.Null,
    'existing_sale_found' : IDL.Null,
    'noop' : IDL.Null,
    'asset_mismatch' : IDL.Null,
    'escrow_cannot_be_removed' : IDL.Null,
    'deposit_burned' : IDL.Null,
    'cannot_restage_minted_token' : IDL.Null,
    'cannot_find_status_in_metadata' : IDL.Null,
    'receipt_data_mismatch' : IDL.Null,
    'validate_deposit_failed' : IDL.Null,
    'unreachable' : IDL.Null,
    'unauthorized_access' : IDL.Null,
    'item_already_minted' : IDL.Null,
    'no_escrow_found' : IDL.Null,
    'escrow_owner_not_the_owner' : IDL.Null,
    'improper_interface' : IDL.Null,
    'app_id_not_found' : IDL.Null,
    'token_non_transferable' : IDL.Null,
    'kyc_error' : IDL.Null,
    'sale_not_over' : IDL.Null,
    'escrow_not_large_enough' : IDL.Null,
    'update_class_error' : IDL.Null,
    'malformed_metadata' : IDL.Null,
    'token_id_mismatch' : IDL.Null,
    'id_not_found_in_metadata' : IDL.Null,
    'auction_not_started' : IDL.Null,
    'library_not_found' : IDL.Null,
    'attempt_to_stage_system_data' : IDL.Null,
    'validate_deposit_wrong_buyer' : IDL.Null,
    'not_enough_storage' : IDL.Null,
    'sales_withdraw_payment_failed' : IDL.Null,
  });
  const OrigynError = IDL.Record({
    'text' : IDL.Text,
    'error' : NFTErrors,
    'number' : IDL.Nat32,
    'flag_point' : IDL.Text,
  });
  const GovernanceResult = IDL.Variant({
    'ok' : GovernanceResponse,
    'err' : OrigynError,
  });
  const StakedTokensRewardsEntry = IDL.Record({
    'date' : IDL.Int,
    'amount' : IDL.Nat64,
  });
  const StakedTokensStable__1 = IDL.Record({
    'redeemedRewards' : IDL.Vec(StakedTokensRewardsEntry),
    'votes' : IDL.Vec(IDL.Tuple(IDL.Int, IDL.Bool)),
    'endLockTime' : IDL.Int,
    'createdDate' : IDL.Int,
    'unlockedQuantity' : IDL.Nat64,
    'last_classification_time' : IDL.Int,
    'unlockedDate' : IDL.Int,
    'rewards' : IDL.Vec(StakedTokensRewardsEntry),
    'quantity' : IDL.Nat64,
    'last_vote' : IDL.Int,
    'dissolving' : IDL.Bool,
    'follow' : IDL.Opt(IDL.Tuple(IDL.Principal, IDL.Nat)),
    'classification' : IDL.Float64,
  });
  const ICTokenSpec = IDL.Record({
    'id' : IDL.Opt(IDL.Nat),
    'fee' : IDL.Opt(IDL.Nat),
    'decimals' : IDL.Nat,
    'canister' : IDL.Principal,
    'standard' : IDL.Variant({
      'ICRC1' : IDL.Null,
      'EXTFungible' : IDL.Null,
      'DIP20' : IDL.Null,
      'Other' : CandyShared,
      'Ledger' : IDL.Null,
    }),
    'symbol' : IDL.Text,
  });
  const TokenSpec = IDL.Variant({
    'ic' : ICTokenSpec,
    'extensible' : CandyShared,
  });
  const UpdateApprovedTokenRequest = IDL.Variant({
    'add' : TokenSpec,
    'remove' : TokenSpec,
  });
  const GovMode = IDL.Variant({ 'Token_2' : IDL.Null, 'Token_3' : IDL.Null });
  const Subaccount = IDL.Vec(IDL.Nat8);
  const Account = IDL.Record({
    'owner' : IDL.Principal,
    'subaccount' : IDL.Opt(Subaccount),
  });
  const ICRC1TransferArgs = IDL.Record({
    'to' : Account,
    'fee' : IDL.Opt(IDL.Nat),
    'memo' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'from_subaccount' : IDL.Opt(Subaccount),
    'created_at_time' : IDL.Opt(IDL.Nat64),
    'amount' : IDL.Nat,
  });
  const AccountIdentifierDFX = IDL.Text;
  const Tokens = IDL.Record({ 'e8s' : IDL.Nat64 });
  const Memo = IDL.Nat64;
  const SubAccount = IDL.Vec(IDL.Nat8);
  const TimeStamp = IDL.Record({ 'timestamp_nanos' : IDL.Nat64 });
  const SendArgs = IDL.Record({
    'to' : AccountIdentifierDFX,
    'fee' : Tokens,
    'memo' : Memo,
    'from_subaccount' : IDL.Opt(SubAccount),
    'created_at_time' : IDL.Opt(TimeStamp),
    'amount' : Tokens,
  });
  const SendSysFundsRequest = IDL.Variant({
    'ICRC1' : ICRC1TransferArgs,
    'Ledger' : SendArgs,
  });
  const GovProposalType_3 = IDL.Variant({
    'ApproveToken' : IDL.Record({
      'url' : IDL.Text,
      'request' : UpdateApprovedTokenRequest,
      'text' : IDL.Text,
    }),
    'CanisterOversight' : IDL.Principal,
    'SetXDRRatio' : IDL.Float64,
    'SetGovMode' : GovMode,
    'SendSysFunds' : IDL.Record({
      'url' : IDL.Text,
      'request' : SendSysFundsRequest,
      'text' : IDL.Text,
      'canister' : IDL.Principal,
    }),
    'Motion' : IDL.Record({ 'url' : IDL.Text, 'text' : IDL.Text }),
  });
  const GovProposalShared_3__1 = IDL.Record({
    'id' : IDL.Int,
    'result' : IDL.Opt(
      IDL.Variant({
        'Failed' : IDL.Null,
        'Passed' : IDL.Null,
        'NoQuorum' : IDL.Null,
      })
    ),
    'expires' : IDL.Int,
    'risked_ogy' : IDL.Nat64,
    'command_type' : GovProposalType_3,
    'for_votes' : IDL.Nat64,
    'proposer' : IDL.Tuple(IDL.Principal, IDL.Nat),
    'voting_power' : IDL.Nat64,
    'against_votes' : IDL.Nat64,
  });
  const GovernanceBackupChunk = IDL.Record({
    'staked' : IDL.Vec(
      IDL.Tuple(IDL.Principal, IDL.Nat, StakedTokensStable__1)
    ),
    'vesting' : IDL.Vec(
      IDL.Tuple(IDL.Principal, IDL.Nat, StakedTokensStable__1)
    ),
    'failed_mint' : IDL.Vec(IDL.Tuple(IDL.Int, IDL.Nat64)),
    'failed_send' : IDL.Vec(
      IDL.Tuple(IDL.Int, IDL.Principal, IDL.Nat64, IDL.Nat64, IDL.Text)
    ),
    'unstaked_balance' : IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Nat64)),
    'redeemed_blocks' : IDL.Vec(IDL.Nat64),
    'proposals' : IDL.Vec(IDL.Tuple(IDL.Int, GovProposalShared_3__1)),
  });
  VarType.fill(
    IDL.Record({
      'key' : IDL.Text,
      'val' : IDL.Variant({
        'Int' : IDL.Int,
        'Nat' : IDL.Nat,
        'Opt' : IDL.Opt(VarType),
        'Nat32' : IDL.Nat32,
        'Nat64' : IDL.Nat64,
        'Blob' : IDL.Vec(IDL.Nat8),
        'Bool' : IDL.Bool,
        'Nat8' : IDL.Nat8,
        'Text' : IDL.Text,
        'Float' : IDL.Float64,
        'Variant' : IDL.Tuple(IDL.Text, IDL.Opt(VarType)),
        'Principal' : IDL.Principal,
        'Class' : IDL.Vec(VarType),
      }),
    })
  );
  const LogEntry = IDL.Record({
    'data' : IDL.Vec(VarType),
    'event' : IDL.Text,
    'timestamp' : IDL.Int,
    'caller' : IDL.Opt(IDL.Principal),
  });
  const GovProposalShared_3 = IDL.Record({
    'id' : IDL.Int,
    'result' : IDL.Opt(
      IDL.Variant({
        'Failed' : IDL.Null,
        'Passed' : IDL.Null,
        'NoQuorum' : IDL.Null,
      })
    ),
    'expires' : IDL.Int,
    'risked_ogy' : IDL.Nat64,
    'command_type' : GovProposalType_3,
    'for_votes' : IDL.Nat64,
    'proposer' : IDL.Tuple(IDL.Principal, IDL.Nat),
    'voting_power' : IDL.Nat64,
    'against_votes' : IDL.Nat64,
  });
  const Balances = IDL.Record({
    'staked' : IDL.Vec(IDL.Tuple(IDL.Nat, StakedTokensStable__1)),
    'unstaked' : IDL.Nat64,
    'vesting' : IDL.Vec(IDL.Tuple(IDL.Nat, StakedTokensStable__1)),
  });
  const ICRC1_Subaccount = IDL.Vec(IDL.Nat8);
  const ICRC1_Account = IDL.Record({
    'owner' : IDL.Principal,
    'subaccount' : IDL.Opt(ICRC1_Subaccount),
  });
  const SubAccountInfo = IDL.Record({
    'account_id' : IDL.Vec(IDL.Nat8),
    'principal' : IDL.Principal,
    'account_id_text' : IDL.Text,
    'icrc1_text' : IDL.Text,
    'account' : ICRC1_Account,
  });
  const ApprovedTokenInfo = IDL.Record({
    'token' : TokenSpec,
    'royalty_account' : SubAccountInfo,
  });
  const Metrics = IDL.Record({
    'last_potential_reward_amount' : IDL.Nat,
    'total_claimable_rewards' : IDL.Nat64,
    'ogy_fee' : IDL.Nat64,
    'last_reward_rate_update' : IDL.Int,
    'potential_vp_credits' : IDL.Float64,
    'gov_mode' : GovMode,
    'locked_tier_1' : IDL.Nat64,
    'locked_tier_2' : IDL.Nat64,
    'locked_tier_3' : IDL.Nat64,
    'locked_tier_4' : IDL.Nat64,
    'locked_tier_5' : IDL.Nat64,
    'ogy_to_xdr' : IDL.Float64,
    'total_staked' : IDL.Nat64,
    'actual_vp_credits' : IDL.Float64,
    'grace_date' : IDL.Int,
    'last_reward_time' : IDL.Int,
    'reward_rate' : IDL.Float64,
    'total_locked_but_not_staked' : IDL.Nat64,
    'approved_tokens' : IDL.Vec(ApprovedTokenInfo),
    'total_unstaked' : IDL.Nat64,
    'last_classification_time' : IDL.Int,
    'accounts' : IDL.Record({
      'allocated_rewards_account' : SubAccountInfo,
      'daos_for_good' : IDL.Record({
        'eco' : SubAccountInfo,
        'arts' : SubAccountInfo,
        'children' : SubAccountInfo,
      }),
      'reward_account' : SubAccountInfo,
      'revenue_account' : SubAccountInfo,
      'funding_stage_account' : SubAccountInfo,
      'development_account' : SubAccountInfo,
    }),
    'total_unclaimed_rewards' : IDL.Nat64,
    'total_in_governance' : IDL.Nat64,
    'total_vesting' : IDL.Nat64,
    'orphaned_rewards' : IDL.Nat,
    'last_reward_length' : IDL.Float64,
    'last_allocated_reward_amount' : IDL.Nat,
    'proposal_count' : IDL.Nat,
    'current_epic_rewards' : IDL.Nat,
    'proposers' : IDL.Vec(IDL.Principal),
    'total_failed_proposal_forfeit' : IDL.Nat64,
    'total_dissolving' : IDL.Nat64,
  });
  const ProposalFilter = IDL.Variant({ 'open' : IDL.Null });
  const StakedTokensStable = IDL.Record({
    'redeemedRewards' : IDL.Vec(StakedTokensRewardsEntry),
    'votes' : IDL.Vec(IDL.Tuple(IDL.Int, IDL.Bool)),
    'endLockTime' : IDL.Int,
    'createdDate' : IDL.Int,
    'unlockedQuantity' : IDL.Nat64,
    'last_classification_time' : IDL.Int,
    'unlockedDate' : IDL.Int,
    'rewards' : IDL.Vec(StakedTokensRewardsEntry),
    'quantity' : IDL.Nat64,
    'last_vote' : IDL.Int,
    'dissolving' : IDL.Bool,
    'follow' : IDL.Opt(IDL.Tuple(IDL.Principal, IDL.Nat)),
    'classification' : IDL.Float64,
  });
  const StakeCommand = IDL.Record({
    'stake_type' : IDL.Variant({ 'staked' : IDL.Null, 'vesting' : IDL.Null }),
    'command' : IDL.Variant({
      'updateDissolve' : IDL.Bool,
      'vote' : IDL.Record({ 'vote' : IDL.Bool, 'proposal' : IDL.Int }),
      'updateEndLockTime' : IDL.Int,
      'proposal' : IDL.Record({
        'command_type' : GovProposalType_3,
        'expires_length' : IDL.Int,
      }),
      'follow' : IDL.Opt(IDL.Tuple(IDL.Principal, IDL.Nat)),
    }),
    'index' : IDL.Nat,
  });
  const ManageStakeResponse = IDL.Variant({
    'Result' : IDL.Bool,
    'Proposal' : IDL.Int,
  });
  const Result = IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text });
  const PrincipalListAction = IDL.Variant({
    'add' : IDL.Principal,
    'remove' : IDL.Principal,
  });
  const TimeMode = IDL.Variant({ 'test' : IDL.Null, 'standard' : IDL.Null });
  const LockPeriods = IDL.Variant({
    'OneYear' : IDL.Null,
    'FiveYear' : IDL.Null,
    'FourYear' : IDL.Null,
    'TwoYear' : IDL.Null,
    'ThreeYear' : IDL.Null,
  });
  const UpdateInflationResponse = IDL.Record({
    'inflation_rate' : IDL.Float64,
    'last_inflation_rate_update' : IDL.Int,
  });
  const AccountIdentifier = IDL.Text;
  return IDL.Service({
    'NFT_Governance' : IDL.Func(
        [IDL.Principal, GovernanceRequest],
        [GovernanceResult],
        [],
      ),
    'NFT_Governance_Batch' : IDL.Func(
        [IDL.Principal, IDL.Vec(GovernanceRequest)],
        [IDL.Vec(GovernanceResult)],
        [],
      ),
    '__move_testtime' : IDL.Func([IDL.Int], [IDL.Int], []),
    'back_up' : IDL.Func(
        [IDL.Nat],
        [
          IDL.Variant({
            'eof' : GovernanceBackupChunk,
            'data' : GovernanceBackupChunk,
          }),
        ],
        ['query'],
      ),
    'burn_vesting_rewards' : IDL.Func(
        [IDL.Principal],
        [IDL.Record({ 'rewards' : IDL.Nat64, 'quantity' : IDL.Nat64 })],
        [],
      ),
    'change_owner' : IDL.Func([IDL.Principal, IDL.Principal], [IDL.Bool], []),
    'classify_staking_rewards' : IDL.Func([], [IDL.Int], []),
    'current_log' : IDL.Func([], [IDL.Vec(LogEntry)], ['query']),
    'finalize_vote' : IDL.Func([IDL.Int], [GovProposalShared_3], []),
    'getAccountID' : IDL.Func([], [IDL.Text], ['query']),
    'get_balances' : IDL.Func([], [Balances], ['query']),
    'get_balances_admin' : IDL.Func(
        [IDL.Principal, IDL.Bool],
        [Balances],
        ['query'],
      ),
    'get_balances_staked_csv' : IDL.Func([], [IDL.Text], ['query']),
    'get_balances_staked_index_csv' : IDL.Func([], [IDL.Text], ['query']),
    'get_balances_unstaked' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Nat64))],
        ['query'],
      ),
    'get_balances_unstaked_csv' : IDL.Func([], [IDL.Text], ['query']),
    'get_balances_v1_5' : IDL.Func(
        [IDL.Opt(IDL.Principal), IDL.Bool],
        [Balances],
        ['query'],
      ),
    'get_balances_vesting_csv' : IDL.Func([], [IDL.Text], ['query']),
    'get_burned_transactions' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Vec(IDL.Nat64)],
        ['query'],
      ),
    'get_ledger_canister_id' : IDL.Func([], [IDL.Principal], ['query']),
    'get_liquidity' : IDL.Func([], [IDL.Nat64], ['query']),
    'get_metrics' : IDL.Func([], [Metrics], ['query']),
    'get_minting_canister_id' : IDL.Func([], [IDL.Principal], ['query']),
    'get_proposal' : IDL.Func(
        [IDL.Int],
        [IDL.Opt(GovProposalShared_3)],
        ['query'],
      ),
    'get_proposals' : IDL.Func(
        [IDL.Nat, IDL.Nat, IDL.Opt(ProposalFilter)],
        [IDL.Vec(GovProposalShared_3)],
        ['query'],
      ),
    'get_stake_periods' : IDL.Func(
        [],
        [
          IDL.Record({
            'two_years_away' : IDL.Int,
            'one_year_away' : IDL.Int,
            'five_years_away' : IDL.Int,
            'four_years_away' : IDL.Int,
            'three_years_away' : IDL.Int,
          }),
        ],
        ['query'],
      ),
    'get_staked_tokens_by_principal' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(StakedTokensStable)],
        ['query'],
      ),
    'get_staked_tokens_principals' : IDL.Func(
        [],
        [IDL.Vec(IDL.Principal)],
        ['query'],
      ),
    'get_vested_tokens_principals' : IDL.Func(
        [],
        [IDL.Vec(IDL.Principal)],
        ['query'],
      ),
    'get_vesting_canister_id' : IDL.Func([], [IDL.Principal], ['query']),
    'get_vesting_tokens_by_principal' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(StakedTokensStable)],
        ['query'],
      ),
    'harvest_log' : IDL.Func([IDL.Nat], [IDL.Vec(IDL.Vec(LogEntry))], []),
    'initialize' : IDL.Func([IDL.Principal], [], []),
    'kill_vesting' : IDL.Func(
        [IDL.Principal, IDL.Vec(IDL.Nat)],
        [IDL.Record({ 'rewards' : IDL.Nat64, 'quantity' : IDL.Nat64 })],
        [],
      ),
    'log_history_page' : IDL.Func([IDL.Nat], [IDL.Vec(LogEntry)], ['query']),
    'log_history_page_chunk' : IDL.Func(
        [IDL.Nat, IDL.Nat, IDL.Nat],
        [IDL.Vec(LogEntry)],
        ['query'],
      ),
    'log_history_size' : IDL.Func([], [IDL.Nat], ['query']),
    'manage_stake' : IDL.Func([StakeCommand], [ManageStakeResponse], []),
    'nuke_log' : IDL.Func([], [], []),
    'predict_vote' : IDL.Func([IDL.Int], [GovProposalShared_3], ['query']),
    'redeem_deposit' : IDL.Func(
        [IDL.Principal, IDL.Opt(IDL.Vec(IDL.Nat8)), IDL.Nat64],
        [IDL.Nat64],
        [],
      ),
    'redeem_rewards' : IDL.Func([IDL.Nat], [IDL.Nat64], []),
    'redeem_rewards_v1_5' : IDL.Func(
        [IDL.Nat, IDL.Bool, IDL.Opt(IDL.Vec(IDL.Nat8))],
        [IDL.Nat64],
        [],
      ),
    'release_vesting_rewards' : IDL.Func([IDL.Principal], [IDL.Nat64], []),
    'retry_mint_and_clear' : IDL.Func([], [IDL.Nat64], []),
    'run_staking_rewards' : IDL.Func([], [IDL.Nat64], []),
    'send_sys_funds' : IDL.Func(
        [IDL.Principal, SendSysFundsRequest],
        [Result],
        [],
      ),
    'set_admin' : IDL.Func([IDL.Principal], [], []),
    'set_data_harvester_id' : IDL.Func([IDL.Principal, IDL.Nat], [], []),
    'set_default_follow' : IDL.Func(
        [IDL.Opt(IDL.Tuple(IDL.Principal, IDL.Nat))],
        [],
        [],
      ),
    'set_distributor' : IDL.Func([IDL.Principal], [], []),
    'set_halt' : IDL.Func([IDL.Bool], [], []),
    'set_ledger_canister_id' : IDL.Func([IDL.Principal], [], []),
    'set_log_harvester_id' : IDL.Func([IDL.Principal], [], []),
    'set_maintenance' : IDL.Func([IDL.Principal], [], []),
    'set_minting_canister_id' : IDL.Func([IDL.Principal], [], []),
    'set_ogy_fee' : IDL.Func([IDL.Nat64], [], []),
    'set_proposer' : IDL.Func([PrincipalListAction], [], []),
    'set_reporter' : IDL.Func([IDL.Principal], [], []),
    'set_test_time' : IDL.Func([IDL.Int], [], []),
    'set_time_mode' : IDL.Func([TimeMode], [], []),
    'set_vesting_canister_id' : IDL.Func([IDL.Principal], [], []),
    'stake_tokens' : IDL.Func([IDL.Nat64, IDL.Int], [IDL.Nat], []),
    'stake_tokens_v1_5' : IDL.Func([IDL.Nat64, LockPeriods], [IDL.Nat], []),
    'staked_tokens_seed' : IDL.Func(
        [IDL.Principal, StakedTokensStable],
        [IDL.Nat],
        [],
      ),
    'sync_metrics' : IDL.Func([IDL.Text], [], []),
    'unstake_tokens' : IDL.Func([IDL.Nat], [IDL.Nat64], []),
    'update_approved_token' : IDL.Func(
        [UpdateApprovedTokenRequest],
        [IDL.Bool],
        [],
      ),
    'update_inflation_rate' : IDL.Func([], [UpdateInflationResponse], []),
    'vest_stake' : IDL.Func([IDL.Principal, IDL.Nat], [IDL.Nat], []),
    'wallet_receive' : IDL.Func([], [IDL.Nat], []),
    'wallet_send' : IDL.Func([IDL.Nat, IDL.Principal], [IDL.Nat], []),
    'withdraw_unlocked_tokens' : IDL.Func(
        [AccountIdentifier, IDL.Nat64],
        [IDL.Nat64],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };